module.exports = __webpack_public_path__ + "img/icons B_32.375cdf30.svg";